module.exports = {
  title: 'Berlin als Häusermeer',
  introtext:'Erkennen Sie auf den neun Häuserkarten die Berliner Orte und Gebäudeumrisse? Stellen Sie sich vor, Berlin würde nur aus Häusern bestehen – ohne Straßen, Grünflächen und Wasserwege. Suchen Sie markante Gebäudeformen! ',
  questions: [
    {
      id: 'Berlin 1',
      lat: 52.516288,
      lng: 13.3766196,
      zoom: 14,
      answers: [
        'bbb',
        'Hamburg',
        'Platz des 18. März'
      ],
      correctAnswer: 'Platz des 18. März'
    },
    {
      id: 'Berlin 2',
      lat: 52.5516502,
      lng: 13.3795613,
      zoom: 14,
      answers: [
        'Berlin',
        'Gesundbrunnen',
        'München'
      ],
      correctAnswer: 'Gesundbrunnen'
    },
    {
      id: 'Berlin 3',
      lat: 52.5621842,
      lng: 13.3243243,
      zoom: 14,
      answers: [
        'Berlin',
        'Kurt-Schumacher-Damm',
        'München'
      ],
      correctAnswer: 'Kurt-Schumacher-Damm'
    },
    {
      id: 'Berlin 4',
      lat: 52.4526154,
      lng: 13.2880058,
      zoom: 14,
      answers: [
        'Freie Universität in Dahlem',
        'Hamburg',
        'München'
      ],
      correctAnswer: 'Freie Universität in Dahlem'
    },
    {
      id: 'Berlin 5',
      lat: 52.4840012,
      lng: 13.3847853,
      zoom: 14,
      answers: [
        'Berlin',
        'Hamburg',
        'Platz der Luftbrücke'
      ],
      correctAnswer: 'Platz der Luftbrücke'
    },
    {
      id: 'Berlin 6',
      lat: 52.5018656,
      lng: 13.4435225,
      zoom: 14,
      answers: [
        'Oberbaumbrücke',
        'Hamburg',
        'München'
      ],
      correctAnswer: 'Oberbaumbrücke'
    },
    {
      id: 'Berlin 7',
      lat: 52.5146492,
      lng: 13.2372503,
      zoom: 14,
      answers: [
        'Berlin',
        'Olympiapark Westend',
        'München'
      ],
      correctAnswer: 'Olympiapark Westend'
    },
    {
      id: 'Berlin 8',
      lat: 52.5388742,
      lng: 13.2059823,
      zoom: 14,
      answers: [
        'Berlin',
        'Hamburg',
        'Altstadt Spandau'
      ],
      correctAnswer: 'Altstadt Spandau'
    },
    {
      id: 'Berlin 9',
      lat: 52.5169642,
      lng: 13.3993653,
      zoom: 14,
      answers: [
        'Berlin',
        'Museumsinsel',
        'München'
      ],
      correctAnswer: 'Museumsinsel'
    }
  ]
}